<template>
    <span :class="[icon, 'icon-' + this.icon]"></span>
</template>

<script>
    export default {
        props: ['icon']
    }
</script>